<template>
  <div class="Md">
    <div class="markdown">
      <div class="md fs22">
        <vue_markdown :source="mdtext"></vue_markdown>
      </div>
    </div>
  </div>
</template>

<script>
 // @ is an alias to /src

 import VueMarkdown from 'vue-markdown'

 export default {
   name: 'SuzhouRule',
   computed: {
     link () {
       return '/oss/markdown/suzhou_rule.md'
     }
   },
   data () {
     return {
       mdtext: '',
       numPages: 0,
     }
   },
   mounted() {
     let that = this
     this.$http.get(this.link)
                     .then(res => {
                       that.mdtext = res.data
                     })
   },
   created () {
     this.$store.commit("SET_FOOTER", false)
     this.$store.commit("SET_HEADER", false)
   },
   components: {
     vue_markdown: VueMarkdown,
   }
 }
</script>

<style scoped>
 .markdown, .pdf{
   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content: center;
 }
 .Md{
   background-color: #22277c;
 }
 .md{
   width: 62.5vw;
   margin-top: 5.2vw;
   margin-bottom: 5.2vw;
   text-align: left;
   color: white;
   box-sizing: border-box;
   padding: 3.125vw 2.6vw 1vw 2.6vw;
   line-height: 1.875vw;
 }

 @media (min-width: 320px) and (max-width: 480px) {
   .md{
     width: 100vw;
     line-height: normal;
   }
 }

</style>
<style>
 .md a{
   color: #FFBA84 !important;
 }
</style>
